@if (!isProd) {
<div class="bg-orange-400/50 text-red-600 font-bold text-xl flex justify-center">
  Ambiente de Teste
</div>
}
<main class="h-screen flex">
  <app-toast></app-toast>
  <div>
    <div class="space-y-4 rounded">
      <app-navbar></app-navbar>
    </div>
  </div>

  <div class="flex flex-1 flex-col">
    <app-header></app-header>
    <h1 class="px-2 py-2 text-primary bg-secondary">{{ currentPath$ | async }}</h1>
    <div
      class="flex-1 bg-gray-100 overflow-y-auto"
      [ngClass]="{
        'py-10 px-40': addPadding
      }"
    >
      <router-outlet />
    </div>
  </div>
</main>
